import { jwtDecode } from "jwt-decode";

let localstorage_list = [
  "user_id",
  "access_token",
  "code",
  "permissions",
  "name",
  "role_name",
  "whoami",
  "role_level",
];

export const UserType = {
  DEALER_BYD: "DEALER_BYD",
  DEALER_DENZA: "DEALER_DENZA",
  REVER: "REVER",
  ADMIN: "ADMIN",
  ACCOUNTANT: "ACCOUNTANT",
  BUSINESS_CONTROL: "BUSINESS_CONTROL",
};

export const ApproverLevel = {
  APPROVER_L1: "APPROVER_L1",
  APPROVER_L2: "APPROVER_L2",
  APPROVER_L3: "APPROVER_L3",
  APPROVER_L4: "APPROVER_L4",
  APPROVER_L5: "APPROVER_L5",
};

const AppUserProfile = {
  getData() {
    let data = {};
    localstorage_list.forEach((name) => {
      data[name] = localStorage.getItem(name);
    });
    return data;
  },

  setData(token) {
    let token_decode = jwtDecode(token);
    let permissions = [];
    let role_name = "";
    token_decode.roles.forEach((role) => {
      role_name = role.Name;
      role.Permissions.forEach((permission) => {
        if (!permissions.includes(permission.name)) {
          permissions.push(permission.name);
        }
      });
    });

    let whoami = null;
    switch (role_name) {
      case "DEALER_BYD":
        whoami = UserType.DEALER_BYD;
        break;
      case "DEALER_DENZA":
        whoami = UserType.DEALER_DENZA;
        break;
      case "ADMIN":
        whoami = UserType.ADMIN;
        break;
      case "ACCOUNTANT":
        whoami = UserType.ACCOUNTANT;
        break;
      case "BUSINESS_CONTROL":
        whoami = UserType.BUSINESS_CONTROL;
        break;
      case "APPROVER_L1":
      case "APPROVER_L2":
      case "APPROVER_L3":
      case "APPROVER_L4":
      case "APPROVER_L5":
        whoami = UserType.REVER;
        role_name = ApproverLevel[role_name];
        break;
      default:
        break;
    }

    let level = role_name.includes("APPROVER")
      ? Number(role_name.split("L").pop())
      : 0;

    localStorage.setItem("user_id", token_decode.id);
    localStorage.setItem("access_token", token);
    localStorage.setItem("code", token_decode.code);
    localStorage.setItem("permissions", JSON.stringify(permissions));
    localStorage.setItem("name", token_decode.name);
    localStorage.setItem("role_name", role_name);
    if (whoami) {
      localStorage.setItem("whoami", whoami);
    } else {
      localStorage.removeItem("whoami");
    }
    localStorage.setItem("role_level", level);
  },

  clearData() {
    localStorage.clear();
  },
};

export default AppUserProfile;
